var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _path12, _path13, _path14;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270 303v96c0 8.28-6.72 15-15 15s-15-6.72-15-15v-96c0-8.28 6.72-15 15-15s15 6.72 15 15z",
    fill: "#dcf0ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270 303v96c0 8.28-6.72 15-15 15V288c8.28 0 15 6.72 15 15z",
    fill: "#bee6fa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M270 111v96c0 8.28-6.72 15-15 15s-15-6.72-15-15v-96c0-8.28 6.72-15 15-15s15 6.72 15 15z",
    fill: "#dcf0ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M270 111v96c0 8.28-6.72 15-15 15V96c8.28 0 15 6.72 15 15z",
    fill: "#bee6fa"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79 240c-8.284 0-15 6.716-15 15s6.716 15 15 15h72c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#dcf0ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M479 167v280c0 8.28-6.72 15-15 15H47c-8.28 0-15-6.72-15-15V63c0-8.28 6.72-15 15-15h160c8.28 0 15 6.72 15 15s-6.72 15-15 15H62v354h387V270h-90c-8.28 0-15-6.72-15-15s6.72-15 15-15h90v-73c0-8.28 6.72-15 15-15s15 6.72 15 15z",
    fill: "#dcf0ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M479 167v280c0 8.28-6.72 15-15 15H255v-30h194V270h-90c-8.28 0-15-6.72-15-15s6.72-15 15-15h90v-73c0-8.28 6.72-15 15-15s15 6.72 15 15z",
    fill: "#bee6fa"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M374 447c0 59.387-128.031 80.247-198.82 47.56C149.91 482.9 136 466.01 136 447c0-59.387 128.031-80.247 198.82-47.56C360.09 411.1 374 427.99 374 447z",
    fill: "#ade232"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M334.82 494.56C313.25 504.52 284.9 510 255 510V384c29.9 0 58.25 5.48 79.82 15.44 52.376 24.168 52.397 70.943 0 95.12z",
    fill: "#9bdc05"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M374 222v66c0 16.57-13.43 30-30 30H166c-16.57 0-30-13.43-30-30v-66c0-16.57 13.43-30 30-30h178c16.57 0 30 13.43 30 30z",
    fill: "#ffe470"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M374 222v66c0 16.57-13.43 30-30 30h-89V192h89c16.57 0 30 13.43 30 30z",
    fill: "#fabe2c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 63,
    fill: "#ade232",
    r: 63
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M318 63c0 34.74-28.26 63-63 63V0c34.74 0 63 28.26 63 63z",
    fill: "#9bdc05"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64 208H30c-16.569 0-30 13.431-30 30v34c0 16.569 13.431 30 30 30h34c16.569 0 30-13.431 30-30v-34c0-16.569-13.431-30-30-30z",
    fill: "#ff7b4a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M480 88h-34c-16.569 0-30 13.431-30 30v34c0 16.569 13.431 30 30 30h34c16.569 0 30-13.431 30-30v-34c0-16.569-13.431-30-30-30z",
    fill: "#ff435b"
  })));
}

export default __webpack_public_path__ + "247d43b7bac07f26e2406af79807d306.svg";
export { SvgDiagram as ReactComponent };